import rely from '@/oauth2-mobile-wx/oauth2rely';
import { Toast } from 'vant';
import axios, {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  Canceler,
} from 'axios';

const handleAuthFail = () => {
  rely.reAuth();
};

const service = axios.create({
  baseURL: window.location.protocol + '//' + window.location.host,
  timeout: 120000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
    AppId: 'Mysoft',
    AppKey: 'ff483a6526ddf275',
  },
  withCredentials: true, // 允许携带cookie
});

const sourceAjaxList: Canceler[] = [];

// 设置 cancel token  用于取消请求 (当一个接口出现401后，取消后续多有发起的请求，避免出现好几个错误提示)
service.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    // ie 环境 get请求 缓存问题
    if (config.method === 'get') {
      const t = new Date().getTime();
      config.params ? (config.params.t = t) : (config.params = { t });
    }

    config.cancelToken = new axios.CancelToken((cancel: Canceler) => {
      sourceAjaxList.push(cancel);
    });

    const tokens = rely.getTokens();
    if (rely.isTokenValid(tokens)) {
      config.headers.Authorization = `Bearer ${tokens.access_token}`; // 让每个请求携带自定义 token
    } else {
      // 刷新token
      await rely.prepareRefresh(
        async () => {
          await rely.refresh(
            (newAccessToken: any) => {
              config.headers.Authorization = `Bearer ${newAccessToken.access_token}`; // 让每个请求携带自定义 token
            },
            () => {
              handleAuthFail();
            },
          );
        },
        () => {
          const newTokens = rely.getTokens();
          config.headers.Authorization = `Bearer ${newTokens.access_token}`;
        },
      );
    }

    return config;
  },
  (error: AxiosError) => {
    console.warn('AxiosError');
    // 抛出错误
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  /* eslint-disable */
  // @ts-ignore
  (response: any) => {
    const { status, data } = response;

    if (status === 200) {

      // console.log('data  ', JSON.stringify(data, null, 2));
      // 如果不出现错误，直接向回调函数内输出 data
      if (data.success && (data.data || {}).Success) {
        return Promise.resolve((data.data || {}).Data);
      } else if (data?.Success) { // 任务中心新接口兼容
        return Promise.resolve(data?.Data);
      } else {
        const config = response.config;
        if (!config) return Promise.reject();
        // 匹配cookie过期，后端重定向的地址
        if (
          response.request.responseURL.indexOf(
            '/PubPlatform/Login/index.aspx',
          ) > -1
        ) {
          const backoff = new Promise<void>((resolve) => {
            setTimeout(() => {
              resolve();
            }, 1000);
          });
          rely.refreshEkpCookie(handleAuthFail);
          return backoff.then(() => {
            return service(config);
          });
        } else {
          Toast.fail(data.message || (data.data || {}).Message || (data?.Message));
          return Promise.reject();
        }
      }
    }
  },
  (error: AxiosError) => {
    console.warn('error');

    const config = error.config;
    if (!config) return Promise.reject(error.message);
    // 匹配cookie过期，后端重定向的地址
    if (
      error.request.responseURL.indexOf('/PubPlatform/Login/index.aspx') > -1
    ) {
      const backoff = new Promise<void>((resolve) => {
        setTimeout(() => {
          resolve();
        }, 1000);
      });
      rely.refreshEkpCookie(handleAuthFail);
      return backoff.then(() => {
        return service(config);
      });
    }

    const resp = error.response;
    if (resp) {
      if (resp.status === 401) {
        handleAuthFail();
      } else if (resp.status === 404) {
        Toast.fail('接口不存在\n请联系管理员！');
      } else if (resp.status) {
        Toast.fail(`服务器异常\n${resp.statusText}`);
      }
    } else {
      Toast.fail('请求未响应\n请联系管理员！');
    }

    // 抛出错误
    return Promise.reject(error.message);
  },
);

export { service as axios };
